import { useTranslation } from 'react-i18next'
import { useCustomer } from 'hooks/useSession'
import TextPaper from '@ui/elements/TextPaper'
import useDateFormat from '@ui/hooks/useDateFormat'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import { hasTextPaperLines } from '@user/customer/confirmation/getTextPaperStatus'

interface Props {
  onPress: () => void
}

export default function PersonalDetails({ onPress }: Props) {
  const { t } = useTranslation(['ui', 'modals'])

  const customer = useCustomer()
  const { needsBirthDate, getDetailStatus } = useConfirmCustomer()
  const { first_name, last_name, ref, birth_date } = customer || {}

  const format = useDateFormat({
    dateStyle: 'medium',
  })

  const lines = [
    [first_name, last_name].filter(Boolean).join(' '),
    birth_date ? format(birth_date) : birth_date,
    ref,
  ]

  const status = getDetailStatus({
    hasData: hasTextPaperLines(lines),
    isValid: !needsBirthDate,
    section: 'personal',
  })

  return (
    <TextPaper
      onPress={onPress}
      icon="user-circle"
      label={t('modals:personal.title')}
      lines={lines}
      status={status}
    />
  )
}
